import type { Router } from 'expo-router';

export type DashboardTab = 'upcoming' | 'performance' | 'ratings';

export function parseDashboardTab(
  value: string | string[] | undefined
): DashboardTab | null {
  const raw = Array.isArray(value) ? value[0] : value;

  if (raw === 'upcoming' || raw === 'performance' || raw === 'ratings') {
    return raw;
  }

  return null;
}

export function parseDashboardMonthCount(value: string | string[] | undefined) {
  const raw = Array.isArray(value) ? value[0] : value;
  const parsed = Number(raw);

  if (!Number.isFinite(parsed) || parsed <= 0) {
    return 12;
  }

  return parsed;
}

export function navigateToDashboardRatings(
  router: Pick<Router, 'navigate'>,
  monthCount: number
) {
  router.navigate({
    pathname: '/partner/dashboard',
    params: { tab: 'ratings', months: String(monthCount) },
  });
}
